import React from 'react';
import { RovLabelScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/rovLabel/RovLabelScore';
import { rovLabelScoreToColorCode } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/rovLabel/rovLabelScoreToColorCode';
import { conditionScoreToScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/rovLabel/rovLabelSettings';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RovLabelScoreLabel = React.memo(function RovLabelScoreLabel(props: { conditionScore: number | undefined | null | string }) {
    if (props.conditionScore === null || props.conditionScore === undefined) {
        return null;
    }
    const rovLabelScore = conditionScoreToScore(props.conditionScore) as RovLabelScore;
    const colorCode = rovLabelScoreToColorCode(rovLabelScore);

    return (
        <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
            {rovLabelScore}
        </span>
    );
});
